import {
  one,
  two,
  three,
  four,
  five, 
  six,
  seven,
  eight,
  nine,
  ten,
  eleven,
  twelve,
  thirteen,
  fourteen,
  fifteen,
  sixteen
} from "./projectImages";

export const projectData = [

  {
    id: 1,
    image: five,
    transitionImage: six,
    title:
    "DevLobby is a vibrant online hub designed for programmers to engage, challenge, and enrich their coding skills. It offers a dynamic environment where members can tackle theoretical puzzles and practical coding problems, while also earning rewards such as achievements. DevLobby aims to provide an entertaining and competitive platform that fosters learning and collaboration among developers.",
    codeLink: "https://github.com/edberv1/DevLobby",
    techStack: ["MongoDB", "Express", "React.js", "Node.js"],
  },
  {
    id: 2,
    image: eight,
    transitionImage: seven,
    title:
    "Pharmacy is an innovative app that revolutionizes the way users access healthcare products. It allows customers to conveniently log in, browse, and purchase medicines online with the ease of a credit card transaction. Additionally, PharmaDiv empowers users to step into the role of pharmacists, offering a platform to sell their own health products, creating a comprehensive marketplace for all healthcare needs.",
    codeLink: "https://github.com/edberv1/Pharmacy",
    techStack: ["MongoDB", "Express", "React.js", "Node.js", "MySQL"],
  },
  {
    id: 3,
    image: three,
    transitionImage: four,
    title:
      "BuySell website is an online platform where individuals and businesses can buy, sell or trade vehicles. The website aims to create a user-friendly experience for customers who want to purchase a vehicle or sell their existing one.",
    codeLink: "https://github.com/edberv1/BuySell",
    techStack: ["Laravel", "TailwindCSS", "AlpineJS"],
  },
  {
    id: 4,
    image: nine,
    transitionImage: ten,
    title:
    "Metalair Nacelles SA is your trusted partner for the localization of lifting platforms, based in Switzerland. With a fleet of more than 100 machines, it has a wide range of platforms adapted to all your needs, whether it is for work at height or specific projects. In addition to localization, it offers transport services for your machines and equipment, ensuring you complete, reliable and secure solutions, from the beginning to the end of your construction sites.",
    codeLink: "https://github.com/edberv1/metalair-necelles",
    liveLink: "https://metalair-nacelles.ch/",
    techStack: ["HTML", "Bootstrap", "EmailJS", "jQuery"],
  },

{
    id: 5,
    image: fourteen,
    transitionImage: thirteen,
    title:
    "Dina-T Glass is a company specializing in the processing and trade of safety glass, offering high-quality solutions for residential, commercial, and industrial applications. The website was built to showcase their wide range of products and services, improve customer engagement, and establish a strong online presence. It features a modern, responsive design with a focus on clarity and functionality, allowing visitors to explore glass types, request quotes, and easily get in touch for custom solutions.",
    codeLink: "https://github.com/edberv1/Dina-T-Glass",
    liveLink: "https://www.dinatglass.com/",
    techStack: ["HTML", "SCSS", "JavaScript","Bootstrap", "EmailJS", ],
  },
 {
    id: 6,
    image: fifteen,
    transitionImage: sixteen,
    title:
    "Ecotek Forage is a Swiss company specializing in geothermal drilling and sustainable energy solutions for residential, commercial, and industrial projects. The website was developed to highlight their expertise, present their services, and build trust with potential clients by showcasing completed projects and innovations in renewable energy. It features a clean, responsive design with an emphasis on clarity and professionalism, enabling visitors to explore services, learn about geothermal benefits, and easily reach out for consultations.",
    codeLink: "https://github.com/edberv1/ecotek-forage",
    liveLink: "https://www.ecotek-forage.ch/",
    techStack: ["HTML", "SCSS", "JavaScript","Bootstrap", "EmailJS"],
  },

  {
    id: 7,
    image: eleven,
    transitionImage: twelve,
    title:
    "SKS Security provides an extensive range of new and proven security services, based in Austria. It also establish individual security services just for your personal needs. Their protection services are designed to be flexible and every member of the team is trained to the highest standards.",
    codeLink: "https://github.com/edberv1",
    liveLink: "https://www.sks-security.at/",
    techStack: ["HTML", "Bootstrap", "Joomla"],
  },
  {
    id: 8,
    image: one,
    transitionImage: two,
    title:
      "Heilmassage-FW is a personal website that I made for a client that provides massage services. Located in Vienna Austria",
    codeLink: "https://github.com/edberv1/Heilmassage-FW",
    liveLink: "https://heilmassage-fw.vercel.app/",
    techStack: ["ReactJs", "TailwindCSS"],
  },
  
  
  
  
  
];
